import { render } from "./Piece.vue?vue&type=template&id=9c122708"
import script from "./Piece.vue?vue&type=script&lang=js"
export * from "./Piece.vue?vue&type=script&lang=js"

import "./Piece.vue?vue&type=style&index=0&id=9c122708&lang=scss"

import exportComponent from "/Users/boris/Developer/me/git/retro-puzzle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__